const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TextFilter"),
    props: {
      filterName: "name_contains",
      label: "Template Name",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DepartmentMultiFilter"),
    props: {
      filterName: "departments_eq",
      label: "Department",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/DestinationFilter"),
    props: {
      filterName: "destinationId",
      label: "Destination",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/BrandMultiFilter"),
    props: {
      filterName: "brands_eq",
      label: "Brand",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/TemplateTypeMultiFilter"),
    props: {
      filterName: "templateTypes_eq",
      label: "Template Type",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../shared/list-filters/InternalStatusMultiFilter"),
    props: {
      filterName: "internalStatus_eq",
      label: "Internal Status",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/templates/templates-filters.js